import styled from 'styled-components';

export const Container = styled.div`
  width: 700px;
  margin: 0 auto;
  @media (max-width: 991px) {
    width: auto;
  }
`;
export const Title = styled.h1`
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0px;
  margin: 25px 0 0;
  text-align: center;
`;
export const MainInfoContent = styled.div`
  background: #ffffffcc;
  border-top: 1px solid #e2e8f0;
  border-radius: 24px;
  box-shadow: 0px 8px 10px -6px #0000001a;
  box-shadow: 0px 20px 25px -5px #0000001a;
  padding: 33px;
  @media (max-width: 767px) {
    padding: 16px;
  }
`;
export const SubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 16px;
`;
export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;

  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  @media (max-width: 575px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const getColumnColors = (columnIndex) => {
  const colors = [
    { color: '#9810FA', background: '#9810FA1A' },
    { color: '#2D6CDF', background: '#2D6CDF1A' },
    { color: '#15C7A7', background: '#15C7A71A' },
    { color: '#FDC700', background: '#F4D2801A' },
  ];
  return colors[columnIndex % 4];
};

export const ProductCardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  > *:last-child:not(:first-child) {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`;

export const ProductCard = styled.div`
  border-radius: 16px;
  background: ${({ $columnIndex }) => getColumnColors($columnIndex).background};
  border: 1px solid transparent;
  border-top: 1.01px solid #ffffffcc;
  box-shadow:
    0px 4.04px 6.05px -4.04px #0000001a,
    0px 10.09px 15.13px -3.03px #0000001a;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 19px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 180px;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `}

  ${({ isActive }) =>
    isActive &&
    `
    border: 1.5px solid #3b82f6;
    background: #ffffff;
    box-shadow: 0px 0px 12px rgba(59, 130, 246, 0.3);
    transform: translateY(-2px);
  `}

  &:hover {
    background: #ffffff;
    transform: translateY(-2px);
  }
`;

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow:
    0px 4.04px 6.05px -4.04px #0000001a,
    0px 10.09px 15.13px -3.03px #0000001a;
`;

export const CardTitle = styled.p`
  font-weight: 700;
  font-size: 14.12px;
  line-height: 20.18px;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ $columnIndex }) => getColumnColors($columnIndex).color};
  margin: 16px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  max-width: 100%;
  min-height: 40px;
`;

export const CardSubText = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ $columnIndex }) => getColumnColors($columnIndex).color};
  margin: 8px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  max-width: 100%;
`;

export const LoadingSpinner = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
  font-size: 16px;
  font-weight: 500;
`;

export const ErrorMessage = styled.div`
  color: #e45270;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;
  font-weight: 500;
`;
